import { Directive, HostListener, ElementRef, Input } from '@angular/core';

@Directive({
  selector: 'input[phoneOnly]'
})
export class PhoneNumberDirective {

  // Default max length = 10 (can be overridden)
  @Input() maxLength: number = 10;

  private allowedKeys = [
    'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
    'ArrowLeft', 'ArrowRight', 'Home', 'End'
  ];

  constructor(private el: ElementRef<HTMLInputElement>) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const key = event.key;

    // Allow special navigation/control keys
    if (this.allowedKeys.includes(key)) return;

    // Allow shortcuts: Ctrl/Cmd + A/C/V/X/Z
    if ((event.ctrlKey || event.metaKey) && 
       ['a','c','v','x','z','A','C','V','X','Z'].includes(key)) {
      return;
    }

    // ❌ No letters, symbols, +, -, spaces, e/E
    if (!/^[0-9]$/.test(key)) {
      event.preventDefault();
      return;
    }

    // ❌ Enforce max length
    const value = this.el.nativeElement.value;
    if (value.length >= this.maxLength) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const pasted = event.clipboardData?.getData('text') ?? '';

    // Allow only continuous digits
    if (!/^[0-9]+$/.test(pasted)) {
      event.preventDefault();
      return;
    }

    // Block if pasted text exceeds maxLength
    const value = this.el.nativeElement.value;
    if ((value.length + pasted.length) > this.maxLength) {
      event.preventDefault();
    }
  }

  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent) {
    const text = event.dataTransfer?.getData('text') ?? '';

    if (!/^[0-9]+$/.test(text)) {
      event.preventDefault();
      return;
    }

    const value = this.el.nativeElement.value;
    if ((value.length + text.length) > this.maxLength) {
      event.preventDefault();
    }
  }
}
